import { render, staticRenderFns } from "./PortalSelect.vue?vue&type=template&id=000c8cea&scoped=true&"
import script from "./PortalSelect.vue?vue&type=script&lang=ts&"
export * from "./PortalSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PortalSelect.vue?vue&type=style&index=0&id=000c8cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c8cea",
  null
  
)

export default component.exports